// Razorpay Checkout loader + opener for per-assessment payments.
// The Checkout script is loaded lazily and only once.

let scriptPromise = null;

export const loadRazorpay = () => {
  if (typeof window !== 'undefined' && window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve) => {
    const s = document.createElement('script');
    s.src = 'https://checkout.razorpay.com/v1/checkout.js';
    s.async = true;
    s.onload = () => resolve(true);
    s.onerror = () => { scriptPromise = null; resolve(false); };
    document.body.appendChild(s);
  });
  return scriptPromise;
};

/**
 * Opens Razorpay Checkout for an existing order.
 * Resolves with { razorpay_payment_id, razorpay_order_id, razorpay_signature }
 * on success; rejects if the user dismisses the modal or the payment fails.
 */
export const openRazorpayCheckout = async ({
  keyId, orderId, amount, currency, name, description, prefill,
}) => {
  const ok = await loadRazorpay();
  if (!ok) throw new Error('Could not load the payment gateway. Check your connection and try again.');
  if (!keyId) throw new Error('Payment gateway is not configured yet. Please contact the administrator.');

  return new Promise((resolve, reject) => {
    const rzp = new window.Razorpay({
      key: keyId,
      order_id: orderId,
      // Amount is display-only here; the server-side order is the source of truth.
      amount: Math.round((Number(amount) || 0) * 100),
      currency: currency || 'INR',
      name: name || 'Vqura Assessment',
      description: description || 'Assessment payment',
      prefill: prefill || {},
      theme: { color: '#1976d2' },
      handler: (response) => resolve(response),
      modal: { ondismiss: () => reject(new Error('Payment cancelled.')) },
    });
    rzp.on('payment.failed', (resp) =>
      reject(new Error(resp?.error?.description || 'Payment failed. Please try again.')));
    rzp.open();
  });
};
